import { render, staticRenderFns } from "./team-details.vue?vue&type=template&id=5ca1b940&"
import script from "./team-details.vue?vue&type=script&lang=js&"
export * from "./team-details.vue?vue&type=script&lang=js&"
import style0 from "./team-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports